'use client'

import type { ReactNode } from 'react'

import { ClickableButton } from '@/components/buttons'
import { handleOpenPdf } from '@/utils'

export type FormButton = {
  text: ReactNode
  /** PDF url opened on click. */
  pdf: string
}

type FormsAndAppendicesProps = {
  /** Inner node of the "Forms & Appendices" heading. */
  heading?: ReactNode
  buttons: FormButton[]
}

/**
 * "Forms & Appendices" section shared across the personal-financing microsite pages.
 * Previously copy-pasted into every PF page view.
 */
/** Hoisted out of the default parameter: React Compiler cannot compile JSX
 *  appearing in a default argument position, which opted this whole component
 *  out of optimization. A module constant is created once, not per render. */
const DEFAULT_HEADING = <span>Forms &amp; appendices</span>

const FormsAndAppendices = ({ heading = DEFAULT_HEADING, buttons }: FormsAndAppendicesProps) => {
  return (
    <section className="section about container" data-aos="fade-up" data-aos-delay="200">
      <div className="d-flex forms pt-4 justify-content-center align-text-center">{heading}</div>

      <div
        className="link-button-row-pf pt-5 justify-content-center"
        data-aos="fade-left"
        data-aos-delay="200"
      >
        {buttons.map((button, index) => (
          <ClickableButton
            key={index}
            text={button.text}
            onClick={() => handleOpenPdf(button.pdf)}
          />
        ))}
      </div>
    </section>
  )
}

export default FormsAndAppendices
